import AdminBar from 'js/admin_bar/AdminBarActivator';
import ArticleToolbar from 'js/journals/article/ArticleToolbar';
import DownloadButton from 'js/journals/article/DownloadButton';
import PodcastPlayer from 'js/journals/article/PodcastPlayer';
import { CitationButton } from 'js/journals/CitationButton';
import { ShareButton } from 'js/journals/ShareButton';
import JournalNavbar from 'js/journals/JournalNavbar';
import { trackCWV } from 'js/utils/trackCWV';
import registerForRails from 'js/utils/registerForRails';
import { trackClick } from 'js/utils/trackClick';
import * as Dismissibles from 'js/utils/dismissibles';
import * as User from 'js/utils/user';
import assignGlobal from 'js/utils/assign_global';
import { Kale } from 'js/core_webpack/metrics/kale';
import { loadRecordHit } from 'js/utils/loadRecordHit';
import { AiTranslationDropdown } from 'js/journals/article/AiTranslationDropdown';
import { ExpandableTable } from 'js/journals/article/ExpandableTable';

assignGlobal('Aedu', { trackClick });
assignGlobal('Aedu', { Dismissibles, User });
assignGlobal('Kale', Kale);

trackCWV();
loadRecordHit();
registerForRails({
  AdminBar,
  ArticleToolbar,
  DownloadButton,
  JournalNavbar,
  CitationButton,
  ShareButton,
  PodcastPlayer,
  AiTranslationDropdown,
  ExpandableTable,
});

window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);

  const triggerDownload = (sourceParam: string) => {
    const downloadButton = document.querySelector(
      '.article-attachment-download-button',
    );
    if (downloadButton instanceof HTMLAnchorElement) {
      const [downloadUrl, downloadUrlParams] = downloadButton.href.split('?');
      const downloadParams = new URLSearchParams(downloadUrlParams);
      downloadParams.set('s', sourceParam);
      window.location.href = `${downloadUrl}?${downloadParams.toString()}`;
    }
  };

  // Map URL parameters to their corresponding source values
  const downloadSources = {
    email_action: 'email',
    article_card: 'article-card',
  } as const;

  // Handle all download cases in a single loop
  Object.entries(downloadSources).forEach(([param, source]) => {
    if (params.get(param) === 'download') {
      triggerDownload(source);
    }
  });
});
